import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { convertValueToUSD } from '../../../helpers/currency.helper';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit-pen.svg';
import { ISummaryData } from '../../../types';
import useStore from '../../../store';

const STYLES = {
  REVIEW_ITEM_CONTAINER: 'flex justify-between',
  REVIEW_ITEM_CONTAINER_BORDER: 'border-b-[1px] border-bw03',
  REVIEW_ITEM_HEADER: 'font-metricR text-bw07 text-[16px] flex items-center',
  REVIEW_AMOUNT: 'text-[22px] text-action03 font-metricRMedium',
  SECTION_TITLE: 'font-metricRMedium text-bw08 text-[18px] leading-6',
  REVIEW_ITEM_KEY: 'font-metricR text-bw07 text-[16px] leading-6 flex items-center',
  EDIT: 'font-metricR text-[16px] text-bw08 underline',
};

interface ITransferDetailsReviewProps {
  onEditAmountClick: () => void;
  amount: string;
}

const TransferDetailsReview = ({ onEditAmountClick, amount }: ITransferDetailsReviewProps) => {
  const { t } = useTranslation();
  const summaryData: ISummaryData = useStore((state) => state.summary);

  const name = `${summaryData.customer.firstName} ${summaryData.customer.lastName}`;

  return (
    <>
      <div className={`${STYLES.REVIEW_ITEM_CONTAINER} mb-[21px]`}>
        <Heading title={t('SEND_MONEY.REVIEW.TRANSFER_DETAILS_TITLE')} className={STYLES.SECTION_TITLE} />
      </div>
      <div className={STYLES.REVIEW_ITEM_CONTAINER}>
        <Heading title={t('SEND_MONEY.REVIEW.ITEMS.AMOUNT')} className={STYLES.REVIEW_ITEM_KEY} />
        <div className='flex'>
          <Heading
            testId='amountToReview'
            title={convertValueToUSD(Number(amount), 2)}
            className={STYLES.REVIEW_AMOUNT}
          />
          <Button
            onClick={onEditAmountClick}
            className='ml-[10px]'
            id=''
            testId='TransferReviewPage-editAmount'
            childElement={<EditIcon className='w-[24px] stroke-bw08' />}
          />
        </div>
      </div>
      <div className='flex justify-between mt-[10px]'>
        <Heading title='From' className='font-metricR text-bw07 text-[16px] items-center' />

        <div className='flex flex-col text-end'>
          <Heading title={name} className=' text-bw08 text-md' />
          <Heading
            title={`${t('MOVE_MONEY.STEPS.INTRO.ACH_OUT.LILI_CHECKING_ACCOUNT')}`}
            className='font-metricR text-bw07 text-md'
          />
        </div>
      </div>
    </>
  );
};

export default TransferDetailsReview;
